define('view/controller/booking/details/DetailsInfoView',['require','marionette','lib/Utils','view/controller/booking/details/BookingLeaveConfirmationView','lib/view/ModalRegion','lib/Navigation'],function (require) {

    var Marionette = require('marionette');
    var Utils = require('lib/Utils');
    var BookingLeaveConfirmationView = require('view/controller/booking/details/BookingLeaveConfirmationView');
    var ModalRegion = require('lib/view/ModalRegion');
    var Navigation = require('lib/Navigation');

    /**
     * Client info form view
     *
     * @class ClientInfoView
     */
    return Marionette.LayoutView.extend({

        template: '#details_booking_info_view',
        modelEvents: {
			'change:location': 'render',
			'change:service': 'render',
            'change:provider': 'render',
            'change:category': 'render',
            'change:products': 'render'
        },
        
        ui: {
            'confirmLink': '.sb-confirm-leave a'
        },
        events: {
            'click @ui.confirmLink': 'confirmLinkClick'
        },

        /**
         * Initialize view
         */
        initialize: function () {
            this.listenTo(this.getOption('clientTimeZone'), 'sync', this.render);
            
            this._timeOffsetModel = this.getOption('timeOffsetModel');
            if (this._timeOffsetModel) {
                this.listenTo(this._timeOffsetModel, 'sync', this.renderView);
            }
        },

        renderView: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        /**
         * Serialize data to display on view
         *
         * @return Object
         */
        serializeData: function () {
            var clientTimeZone = this.getOption('clientTimeZone');
            var nowDiff = parseInt(clientTimeZone.get('time_diff'), 10) || 0;
            // offset of the selected date/time (and of each recurring date) resolved on the server for that
            // date; the warning tells the client it differs from the current offset of their timezone (DST)
            var timeDiff = Utils.bookingTimeDiff(this.model, this._timeOffsetModel, clientTimeZone);
            // the notice is shown next to each date whose offset differs from the current one (DST between
            // today and that date): time_diff_warning for the start date, recurring_warnings per recurring date,
            // time_diff_warning_any for themes that show a single notice for the whole list
            var timeDiffWarning = timeDiff != nowDiff;
            var recurringDiffs = null;
            var recurringWarnings = {};
            var anyWarning = timeDiffWarning;

            if (this._timeOffsetModel && this._timeOffsetModel.get('time_diffs') && !_.isEmpty(this._timeOffsetModel.get('time_diffs'))) {
                recurringDiffs = this._timeOffsetModel.get('time_diffs');

                _.each(recurringDiffs, function (diff, date) {
                    recurringWarnings[date] = diff != nowDiff;
                    anyWarning = anyWarning || recurringWarnings[date];
                });
            }

            if (this.model.get('wl')) {
                // waiting list entries are date-only
                timeDiff = 0;
                timeDiffWarning = false;
                recurringWarnings = {};
                anyWarning = false;
            }

            var data = _.extend(Marionette.LayoutView.prototype.serializeData.call(this), {
                time_diff: timeDiff,
                time_diff_warning: timeDiffWarning,
                time_diff_warning_any: anyWarning,
                recurring_dates: this.getOption('timeValidateModel').get('dates'),
                recurring_diffs: recurringDiffs,
                recurring_warnings: recurringWarnings
            });
            return data;
        },
        
        confirmLinkClick: function (evt) {
            evt.preventDefault();
            
            var $target = $(evt.currentTarget);
            var link = $target.attr('href');
            
            var region = new ModalRegion();
            var view = new BookingLeaveConfirmationView();
            region.show(view);

            this.listenTo(view, 'confirm', function () {
                Navigation.go(link);
            });
        }

    });

});
